<birdz-panel>
  <mat-tab-group
    [(selectedIndex)]="selectedTab"
    animationDuration="200ms"
    [mat-stretch-tabs]="false"
    class="birdz-filter-tab-group"
  >
    <mat-tab label="{{ 'FILTERS' | transloco }}">
      @if (form) {
        <form class="filters" [formGroup]="form">
          @if (isLoading) {
            <div class="loader">
              <mat-spinner diameter="20"></mat-spinner>
            </div>
          }
          <mat-accordion [multi]="true" class="bdz-filter-accordion">
            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title> {{ 'PERIMETER' | transloco }} </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="perimeter">
                <!-- contracts -->
                @if (showContractFilter) {
                  <mat-form-field>
                    <mat-label> {{ 'CONTRACT' | transloco }} </mat-label>
                    <mat-select
                      birdzSelectWithVirtualScroll
                      (openedChange)="!$event && updateOptions()"
                      (selectionChange)="updateOptions()"
                      formControlName="contract"
                      panelClass="birdz-wide-select"
                      class="bdz-select-trigger-small-font"
                      [optionToLabel]="contractOptionToLabel"
                    >
                      <!-- search bar -->
                      <birdz-select-search-bar
                        birdzSelectOnEnterWhenUnique
                        [options]="options.contracts"
                        [searchFunction]="searchContractFn"
                        #contractSearch
                      >
                      </birdz-select-search-bar>
                      <!-- filtered options -->
                      <cdk-virtual-scroll-viewport>
                        <mat-option
                          *cdkVirtualFor="let contract of options.contracts | filter: contractSearch.filter"
                          [value]="contract.id"
                          matTooltip="{{ contract.label }}"
                          matTooltipPosition="after"
                          matTooltipShowDelay="500"
                        >
                          {{ contract.id }} - {{ contract.label }}
                        </mat-option>
                      </cdk-virtual-scroll-viewport>
                    </mat-select>
                  </mat-form-field>
                }

                <!-- geocodes -->
                <mat-form-field>
                  <mat-label>
                    {{ 'GEOCODES' | transloco }} ({{ form.get('geocodes')?.value?.length ?? 0 | formatNumber }})
                  </mat-label>
                  <mat-select
                    birdzSelectWithVirtualScroll
                    [optionToLabel]="geocodeOptionToLabel"
                    multiple
                    panelClass="birdz-wide-select"
                    formControlName="geocodes"
                  >
                    <!-- search bar -->
                    <birdz-select-search-bar
                      birdzSelectOnEnterWhenUnique
                      [options]="options.geocodes"
                      [searchFunction]="searchGeocodeFn"
                      #geocodeSearch
                    >
                    </birdz-select-search-bar>
                    <!-- filtered options -->
                    <cdk-virtual-scroll-viewport>
                      <mat-option
                        *cdkVirtualFor="let geocode of options.geocodes | filter: geocodeSearch.filter"
                        [value]="geocode.id"
                        matTooltip="{{ geocode.city_name }}"
                        matTooltipPosition="after"
                        matTooltipShowDelay="500"
                      >
                        {{ geocode.city_name }}
                      </mat-option>
                    </cdk-virtual-scroll-viewport>
                  </mat-select>
                </mat-form-field>

                <!-- technos -->
                @if (options.technos.length > 1) {
                  <mat-form-field>
                    <mat-label> {{ 'TECHNO' | transloco }} </mat-label>
                    <mat-select
                      #technoSelect
                      birdzSelectWithVirtualScroll
                      formControlName="techno"
                      [optionToLabel]="technoOptionToLabel"
                    >
                      <!-- search bar -->
                      <birdz-select-search-bar birdzSelectOnEnterWhenUnique [options]="options.technos" #technoSearch>
                      </birdz-select-search-bar>
                      <!-- filtered options -->
                      <cdk-virtual-scroll-viewport>
                        <mat-option
                          *cdkVirtualFor="let techno of options.technos | filter: technoSearch.filter"
                          [value]="techno.id"
                          matTooltip="{{ techno.label }}"
                          matTooltipPosition="after"
                          matTooltipShowDelay="500"
                        >
                          {{ techno.label }}
                        </mat-option>
                      </cdk-virtual-scroll-viewport>
                    </mat-select>
                  </mat-form-field>
                }
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </form>
      }
    </mat-tab>
  </mat-tab-group>

  <!-- footer -->
  <div footer class="footer">
    @if (form) {
      <form [formGroup]="form">
        <button matButton="outlined" (click)="reset()">
          {{ 'RESET_FILTERS' | transloco }}
        </button>
        <button matButton="filled" [disabled]="form.invalid || isApplied" (click)="submit()">
          {{ 'APPLY' | transloco }}
        </button>
      </form>
    }
  </div>
</birdz-panel>
